import { APP_AUTH_RESULT } from './globalState';
import { getOrThrow, has } from 'quartz/globalState/api';
export const getAppAuthResult = () => {
  if (!has(APP_AUTH_RESULT)) {
    throw new Error('App auth not initialized');
  }
  return getOrThrow(APP_AUTH_RESULT);
};